const icons = {
	'SYSOFFICE':	'fas fa-briefcase',
	'SYSMEDICAL':	'fas fa-file-medical',
	'NOTICE':			'fas fa-bullhorn',
	'ATTEND':			'far fa-calendar-check',
	'DISC':				'fas fa-gavel',

	'pdf':		'fa fa-file-pdf',
	'image':	'fa fa-file-image',
	'png':		'fa fa-file-image',

	'REPORT-TYPE-A':			'fas fa-bullhorn',
	'REPORT-TYPE-D':			'fas fa-inbox',
	'REPORT-TYPE-E':			'fas fa-calendar-week',
	'REPORT-TYPE-F':			'fas fa-paperclip',
	'REPORT-TYPE-G':			'fas fa-spell-check',
	'REPORT-TYPE-L':			'fas fa-link',
	'REPORT-TYPE-O':			'fas fa-folder',
	'REPORT-TYPE-O-open':	'fas fa-folder-open',
	'REPORT-TYPE-P':			'fas fa-scroll',
	'REPORT-TYPE-T':			'fas fa-comments',
	'REPORT-TYPE-GRD':		'fas fa-tasks'
};

export const iconClass = code => {
	return icons[ code ];
}
